import { render, staticRenderFns } from "./AdminHealth.vue?vue&type=template&id=5b217dd2&scoped=true&"
import script from "./AdminHealth.vue?vue&type=script&lang=js&"
export * from "./AdminHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b217dd2",
  null
  
)

export default component.exports